<template>
  <div class="page-upload-video xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">上传音乐</div>
          <div class="xc-modal-close" @click="layerClose"></div>
        </div>
        <div
          class="xc-modal-body"
          v-loading="loading"
          element-loading-text="上传中，请稍后..."
        >
          <div v-if="channel == '0'">
            <form class="form">
              <xc-form-item
                label="播放时长(秒)"
                class="xc-form-item-fixed"
                required
              >
                <span v-if="data.files && data.files.length">
                  <input
                    type="text"
                    disabled="disabled"
                    class="xc-input xc-input-disabled"
                    :value="(data.files[0].duration || 0) / 1000"
                  />
                </span>
                <span v-else>
                  <input
                    type="text"
                    disabled="disabled"
                    value="0"
                    class="xc-input xc-input-disabled"
                  />
                </span>
              </xc-form-item>
              <xc-form-item
                label="音乐"
                style="align-items: inherit"
                required
                class="position-upload"
              >
                <xc-upload1
                  :fileList.sync="data.files"
                  type="0"
                  accept=".mp3"
                  :url="uploadUrl"
                  :multiple="true"
                  :beforeUpload="beforeUpload"
                />
                <input
                  type="file"
                  class="file-input"
                  id="file-selector"
                  size="small"
                  accept=".mp3"
                  @change="changeFile"
                  @del="del"
                />
              </xc-form-item>
            </form>
          </div>
          <div v-if="channel == '1'">
            <form class="form" style="width: 267px">
              <xc-form-item
                label="选择分组"
                required=""
                :error="errors.first('groupId')"
              >
                <select
                  name="groupId"
                  class="xc-select"
                  v-validate="'required'"
                  data-vv-as="分组"
                  v-model="fileGroupId"
                >
                  <option value="">请选择</option>
                  <template v-if="fileGroups.length">
                    <option
                      v-for="(item, index) in fileGroups"
                      :key="index"
                      :value="item.fileGroupId"
                    >
                      {{ item.fileGroupName }}
                    </option>
                  </template>
                </select>
              </xc-form-item>
              <xc-form-item
                label="音乐"
                style="align-items: inherit"
                required
                class="position-upload"
              >
                <xc-upload1
                  :fileList.sync="data.files"
                  type="0"
                  accept=".mp3"
                  :url="uploadUrl"
                  :multiple="true"
                  :beforeUpload="beforeUpload"
                  @del="del"
                />
                <input
                  type="file"
                  class="file-input"
                  id="file-selector"
                  size="small"
                  accept=".mp3"
                  @change="changeFile"
                />
              </xc-form-item>
            </form>
          </div>
        </div>
        <div class="xc-modal-footer xc-flex-center">
          <div class="xc-btn-group">
            <div class="xc-btn xc-btn-default" @click="layerClose">取消</div>
            <div class="xc-btn xc-btn-primary" @click.prevent="submit">
              确定
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import "@/libs/vee-validate";
// import myLayerImport from '@/libs/myLayer'
import material from "@/api/material";
// myLayerImport();
import { uploadFile, getVideoImg } from "@/utils/uploadfile";
import { Message } from "element-ui";
import sysconfigApi from "@/api/sysconfig";
export default {
  name: "materialUploadImage",
  data() {
    return {
      // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
      channel: this.$route.query.channel || 0,
      fileGroups: [], //素材分组
      fileGroupId: this.$route.query.fileGroupId || "", //当前分组ID
      data: {
        duration: 0,
        files: [],
      },
      // uploadUrl: "/file/uploadVideo",
      uploadUrl: "",
      loading: false,
    };
  },

  created() {
    var _this = this;
    // 获取channel
    this.channel = this.$route.query.channel;
    if (this.channel == 1) {
      //    获取素材分组
      material
        .getFileGroup()
        .then(function (success) {
          _this.fileGroups = success.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    // 获取系统设置
    sysconfigApi.getConfig().then((ret) => {
      const sysConfig = {};
      ret.data.map((item) => {
        sysConfig[item.type] = item;
      });

      this.sysConfig = sysConfig;
    });
  },

  methods: {
    changeFile(event) {
      let file = event.target.files[0];
      if (!file) return;
      this.loading = true;
      this.cosUploadFile(file);
    },
    // 通过腾讯云 cos-js-sdk-v5 上传
    cosUploadFile(file) {
      uploadFile(file, async (err, data) => {
        if (err) {
          console.log(err);
        } else {
          console.log(data, "data");
          let fileData = JSON.parse(JSON.stringify(data));
          var au = document.createElement("audio");
          au.src = data.fid;
          var duration = 0;
          await new Promise(function (resolve, reject) {
            au.addEventListener(
              "loadedmetadata",
              () => {
                duration = au.duration;
                resolve(duration);
              },
              false
            );
          });
          // let res = await getVideoImg(data.fid);
          // console.log(res, "res");
          this.loading = false;
          fileData.fileImageUrl = "";
          fileData.duration = Number(parseInt(duration * 1000));
          fileData.url = data.fid;
          fileData.file = data.fid;
          fileData.md5 = file.md5;
          fileData.type = file.type;
          fileData.name = file.name;
          fileData.size = file.size;
          fileData.fileType = "image";
          fileData.fileSuffix = file.name.split(".")[1];
          fileData.fileName = file.name.split(".")[0];
          fileData.status = "success";
          console.log(fileData, "fileData");
          fileData.programModel = "audio";
          this.data.files.push(fileData);
          console.log(this.data.files, "this.data.files");
        }
      });
    },
    del() {
      document.getElementById("file-selector").value = "";
    },
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },

    submit() {
      this.$validator.validateAll().then((validate) => {
        if (validate) {
          if (!this.data.files || this.data.files.length == 0) {
            this.$message.error("请上传音乐");
            return;
          }

          const file = this.data.files[0];
          if (!file.url) {
            return this.$message.error("请上传音乐");
          }

          const returnData = this.data.files.map((file) => {
            return {
              duration: Number(parseInt(file.duration)),
              fileSuffix: file.fileSuffix,
              url: file.url,
              fileName: file.fileName,
              md5: file.md5,
              size: file.size,
              fileType: "audio",
              //   fileImageUrl: file.fileImageUrl,
              fileGroupId: this.fileGroupId,
            };
          });

          const confirmData = this.data.files.map((file) => {
            return {
              ...file,
              fileType: "audio",
              groupId: this.fileGroupId,
            };
          });

          // 将素材入库
          material
            .uploadSure({
              files: JSON.stringify(confirmData),
            })
            .then(() => {
              parent.window.audioUploadSubmit(returnData);
              this.layerClose();
            });
        } else {
          let error = this.errors.items[0].msg;
          this.$message.error(error);
        }
      });
    },

    beforeUpload(file) {
      if (!this.sysConfig.upload_max_video_size) {
        this.$message.error("上传配置获取识别，请稍后重试");
        return false;
      }

      const maxSize = this.sysConfig.upload_max_video_size.value * 1024 * 1024;
      const passSuffix = this.sysConfig.pass_video_suffix.value.split(",");

      if (file.size > maxSize) {
        this.$message.error(
          "音乐大小不能超过" + this.sysConfig.upload_max_video_size.value + "MB"
        );
        return false;
      }

      const suffixAry = file.name.split(".");
      if (suffixAry.length == 0) {
        this.$message.error(
          "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
        );
        return false;
      }

      // 判断是否允许的格式
      const allowType = passSuffix.some((item) => {
        return suffixAry[suffixAry.length - 1] == item;
      });

      // 不允许的文件格式
      if (!allowType) {
        this.$message.error(
          "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
        );
        return false;
      }
    },
  },
};
</script>
  
  <style lang="scss">
.page-upload-video {
  .xc-form-item-label {
    min-width: 90px;
  }
}
.position-upload {
  position: relative;
}
.file-input {
  position: absolute;
  top: 0;
  min-height: 40px;
  opacity: 0;
}
</style>
  
  